import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Api } from '../monolith/api.service';
import { getAppVersion } from '@lentau/api/shared/shared/api.helper';
import { JsonRpcBody } from '@lentau/api/shared/jrpc//types';

@Injectable({
  providedIn: 'root',
})
export class Jrpc extends Api {
  public post<T>(method: string, body = {}, head = {}, options = {}): Observable<T> {
    const normalizeMethod = this.normalizeMethodTitle(method);

    const headers = new HttpHeaders({
      Client: getAppVersion(),
      MarketingPartnerKey: this.marketingPartnerKey(),
      ...head,
    });

    options = { ...options, headers };

    const dataRpc: JsonRpcBody = {
      method: normalizeMethod,
      params: { ...body },
      jsonrpc: '2.0',
    };

    const apiUrl: string = this.browserApi.isBrowser()
      ? this.window.location.origin
      : this.configService.configs.apiUrl;

    return this.http.post<T>(`${apiUrl}/jrpc/${normalizeMethod}`, JSON.stringify(dataRpc), options);
  }
}
